import Vue from 'vue'

Vue.filter('minute', function (value) {
  if (value === null || value === undefined || isNaN(value)) return '--'
  let time = Number(value)
  let h = Math.floor(time / 60)
  let m = Math.floor(time % 60)
  let s = Number(parseFloat(time % 60 - Math.floor(time % 60)).toFixed(2)) * 60
  s = Math.floor(s)
  // h = h < 10 ? '0' + h : h
  m = m < 10 ? '0' + m : m
  s = s < 10 ? '0' + s : s
  let ht = h ? `${h < 10 ? '0' + h : h}小时` : ''
  return `${ht}${m}分${s}秒`
})
